import React from "react";

export default function Liquidity() {
  return <div>Liquidity</div>;
}
